import { createApp } from 'vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import GUeditor from "@/components/admin/article/GUeditor";

const app = createApp(App)
import * as ElIcons from "@element-plus/icons-vue";
for (const iconName in ElIcons) {
    app.component(iconName, ElIcons[iconName]);
}
app.component("GUeditor", GUeditor)
app.use(ElementPlus).use(router)
app.mount('#app')

